import { format } from 'date-fns';
import { useState, useEffect, FC } from 'react';
import { YStack, Image, Text, View } from 'tamagui';

import { homeGuardianLogo } from '../../assets';

export const LogoTimeDate: FC = () => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const time = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
  const date = format(now, 'EEEE, MMMM do');

  return (
    <YStack flexDirection="column" alignItems="flex-start" gap="$5">
      <Image
        source={{ uri: homeGuardianLogo }}
        alt="Delta Logo"
        width={172}
        height={172}
        resizeMode="contain"
      />
      <View
        justifyContent="center"
        alignItems="flex-start"
        padding="$4"
        backgroundColor="transparent"
        zIndex={999}>
        <Text fontFamily="$heading" fontSize={94} fontWeight="$5" color="$color12" textAlign="left">
          {time}
        </Text>
        <Text fontFamily="$heading" fontSize="$8" fontWeight="$4" color="$color12" textAlign="left">
          {date}
        </Text>
      </View>
    </YStack>
  );
};
